let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("945OG")).then(() => parcelRequire('biU84'));